import axios from "axios";

import { BASE_URL } from "../../src/utils/api_base_url_configration";

const token = localStorage.getItem("token");

const getConfig = () => {
  return {
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
};

// about-us details fetch
export const getAboutServ = async () => {
  try {
    const response = await axios.get(BASE_URL + "about/details");
    return response;
  } catch (error) {
    console.error("Error fetching about us:", error);
    throw error;
  }
};

// upper content (title + description) update
export const updateAboutContentServ = async (payload) => {
  try {
    const response = await axios.put(BASE_URL + "about/update-content", payload);
    return response;
  } catch (error) {
    console.error("Error updating about content:", error);
    throw error;
  }
};

// 3 cards update (multipart -> title/subtitle + optional images)
export const updateAboutCardsServ = async (formData) => {
  try {
    const response = await axios.put(
      BASE_URL + "about/update-cards",
      formData,
      getConfig()
    );
    return response;
  } catch (error) {
    console.error("Error updating about cards:", error);
    throw error;
  }
};
